import { render, staticRenderFns } from "./QuickMenu.vue?vue&type=template&id=91f7cdc4&scoped=true&"
import script from "./QuickMenu.vue?vue&type=script&lang=js&"
export * from "./QuickMenu.vue?vue&type=script&lang=js&"
import style0 from "./QuickMenu.vue?vue&type=style&index=0&id=91f7cdc4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f7cdc4",
  null
  
)

export default component.exports